import { useNavigate, useParams } from 'react-router-dom';
import { Row, Col} from 'react-bootstrap';
import SectionTitle from '../../../sitel/demon/ui/atoms/sectionTitle';
import { exemptionPageTitle, exemptionStatus } from '../../../services/exemptions';
import nextActionMatrix, { possibleWizardSteps, stepToUrl } from '../../../services/nextActionMatrix';
import { createRequest } from '../../../services/api';
import NukeRequest from '../../../components/atoms/nukeRequest';
import DisclaimerByExemption from './disclaimerByExemption';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import SubmitButton from '../../../sitel/demon/ui/atoms/buttons/SubmitButton';

export default function Step1Disclaimer() {
  const { exemptionType } = useParams();
  const navigate = useNavigate();

  // form validation rules
  const validationSchema = Yup.object().shape({
    acceptTerms: Yup.bool().oneOf([true], 'Please check this box to acknowledge that you have read and agree with the above disclaimer.'),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  // get functions to build form with useForm() hook
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm(formOptions);

  function onSubmit() {
    // success
    handleCreateNewExemption();
    return false;
  }

  const handleCreateNewExemption = () => {
    createRequest(
      exemptionType,

      (r) => {
        console.log('handleCreateNewExemption createRequest:', r);
        const id = r.data.payload.ohrequest_id;
        const stepurl = stepToUrl[nextActionMatrix(exemptionStatus.draft.key, exemptionType, possibleWizardSteps.aknowledgement)];
        navigate(`/${stepurl}/${exemptionType}/${id}`);
      },

      (r) => console.error('Failed creating a new exemption', r)
    );
  };

  // This block of code represents the best and quickest solution since a request has to be created regardless.
  // If the exemption type is "medFluVax" or "relFluVax", we can skip showing a disclaimer screen and directly call handleCreateNewExemption(),
  // proceeding to the next step seamlessly.
  // TODO (itay 20230804) This specific exemption logic should be moved out, to the nextsteps calculator.
  //      The next step calculator (or something near it) should be the place where we create an exemption if none exixts.
  //      Reason for this needed separation, right now, the entire flow depends on the aknowlegment steps (disclaimer) which is 
  //      not a mandatory step as initially was thought.
  // TODO Make this handleCreateNewExemption a new first page in the wizard.
  if (exemptionType === "medFluVax" || exemptionType === "relFluVax") {
    handleCreateNewExemption();
    return;
  }

  return (
    <>
      <SectionTitle>{exemptionPageTitle[exemptionType]}</SectionTitle>
      <Row className='bg-body rounded shadow-sm mb-5'>
        <Col className='p-5'>
          <h5>Disclaimer</h5>
          <hr style={{ boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.8)' }} />
          <DisclaimerByExemption exemptionType={exemptionType} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='form-group form-check'>
              <input name='acceptTerms' type='checkbox' {...register('acceptTerms')} id='acceptTerms' className={`form-check-input ${errors.acceptTerms ? 'is-invalid' : ''}`} />
              <label htmlFor='acceptTerms' className='form-check-label'>
                I Agree to the Terms & Conditions
              </label>
              <div className='invalid-feedback'>{errors.acceptTerms?.message}</div>
            </div>
            <div className='form-group mt-3'>
              <SubmitButton isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful} defaultLabel="Continue With Request" className="btn-medstar-primary me-2"/>
              <NukeRequest>Cancel Request</NukeRequest>
            </div>
          </form>
        </Col>
      </Row>
    </>
  );
};
